import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './servicestyle.css';
import technicaldesing from '../../../assets/images/technicaldesing.svg';
import Instalation from '../../../assets/images/Instalation.svg';
import aftersales from '../../../assets/images/Aftersales.svg';
import AfterSales from '../ServiceInfo/AfterSales/AfterSales';
import TechnicalDesing from './TechnicalDesing/technicaldesing';
import Installing from './Instalation/Installing';

const ServiceComponent = () => {
  const [activeIcon, setActiveIcon] = useState(null);
  const { t, i18n } = useTranslation();
  const languageClass = i18n.language === 'ka' ? 'georgian' : 'english';

  const handleIconClick = (iconName) => {
    setActiveIcon(activeIcon === iconName ? null : iconName);
  };

  return (
    <div className={`main-page ${languageClass}`}>
      <div className={`icons ${languageClass}`}>
        <button onClick={() => handleIconClick('technicalDesign')} className={languageClass}>
          <img src={technicaldesing} alt="Technical Design" />
          {t('Technical Design')}
        </button>
        <button onClick={() => handleIconClick('afterSales')} className={languageClass}>
          <img src={aftersales} alt="After-Sales Technical Assistance" />
          {t('After-Sales Technical Assistance')}
        </button>
        <button onClick={() => handleIconClick('installation')} className={languageClass}>
          <img src={Instalation} alt="Installation" />
          {t('Installation')}
        </button>
      </div>

      <div className={`details ${languageClass}`}>
        {activeIcon === 'technicalDesign' && (
          <TechnicalDesing />
        )}
        {activeIcon === 'afterSales' && (
          <AfterSales />
        )}
        {activeIcon === 'installation' && (
          <Installing />
        )}
      </div>
    </div>
  );
};

export default ServiceComponent;
